<template>
  <!-- 这个是项目管理 -->
  <div class="projectManagement">
    <div class="title_box">
      <el-col :span="13">
        <h4>共识撰写</h4>
      </el-col>
      <!-- 左边的输入框 -->
      <div class="inputBox">
        <el-input
          :clearable="true"
          placeholder="请输入共识名称"
          v-model="input2"
          style="width:332px; margin-right: 16px;"
          @change="change"
        >
        </el-input>
        <el-button
          size="medium"
          style="background: #484c7f; color: #fff"
          @click="Search"
        >搜索</el-button>
      </div>
      <!-- 搜索区域 -->
      <div class="searchBox">
        <!-- 右侧的按钮 -->
        <div class="buttonBox">
          <el-button
            size="medium"
            style="background: #258ce8; color: #fff"
            @click="addConsensus"
          >添加共识</el-button>
          <el-button
            size="medium"
            style="background: #6c757d; color: #fff"
            @click="backProject"
          >返回项目主页</el-button>
        </div>
      </div>
    </div>
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索区域结束 -->
      <!-- 列表区域 -->
      <div class="table_box">
        <el-table
          :data="ConsensusList.list"
          style="width: 100%"
        >
          <el-table-column
            label="项目名称"
            min-width="30%"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.name"
                placement="top-start"
              >
                <span> {{ scope.row.name }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="执笔人"
            min-width="25%"
          >
            <template slot-scope="scope">
              <el-tooltip
                visible-arrow
                class="item"
                effect="light"
                :content="scope.row.writer.map(item =>item).join('，')"
                placement="top-start"
              >
                <div>
                  <span
                    v-for="(item,index) in scope.row.writer"
                    :key="index"
                  >
                    <span v-if="scope.row.writer.length!=0 && index < 3 ">
                      <span>{{item}}</span>
                      <span
                        v-if="index !== (scope.row.writer.length<=2?scope.row.writer.length-1:2)"
                      >，</span>
                    </span>
                  </span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="200px"
          >
            <template slot-scope="scope">
              <!-- 这里是三个图标 -->
              <el-tooltip
                class="item"
                effect="light"
                content="选择"
                placement="top-start"
              >
                <span
                  v-throttle
                  v-if="scope.row.is_chooes==0"
                  class="iconstyle lookat"
                  @click="selectConsensus(scope.row)"
                >
                  <img src="../../assets/image/Designation.png">
                </span>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="light"
                content="取消选择"
                placement="top-start"
              >
                <span
                  v-if="scope.row.is_chooes==1"
                  class="iconstyle lookat "
                  @click="CancellationConsensus(scope.row)"
                >
                  <img src="../../assets/image/CancellationConference.png">
                </span>
              </el-tooltip>

              <span
                class="iconstyle lookat iconfont icon-chakan"
                @click="viewConsensus(scope.row)"
              ></span>
              <span
                class="iconstyle edtor iconfont icon-bianji"
                @click="editorConsensus(scope.row)"
              ></span>
              <span
                class="iconstyle delete iconfont icon-shanchu"
                @click="deleteConsensus(scope.row)"
              ></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 列表区域结束 -->
    </el-card>
    <!-- 这里边是一个分页 -->
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentchange"
        @prev-click="prevClick"
        @next-click="nextClick"
        :page-count="ConsensusList.pages"
        :current-page.sync="currentPage"
        hide-on-single-page
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      value: '',
      options: [],
      input2: '',
      cateIndex: '',
      ConsensusList: {},
      project_id: '',
      currentPage: 1,//当前页数   
    }
  },
  created () {
    //Consensus
    if (this.$route.query.project_id != '' && this.$route.query.project_id != null && this.$route.query.project_id != undefined) {
      this.project_id = this.$route.query.project_id
    }
    this.getConsensusList()
  },
  methods: {
    //获取共识列表
    async getConsensusList () {
      const { data: data } = await this.$http.post('gs/list', {
        cate_id: this.cateIndex,//会议分类id 
        name: this.input2,//会议名称
        project_id: this.project_id,//项目id  
        page: this.currentPage,//分页
        limit: 8,//一页几条数据  
      })
      this.ConsensusList = data.data
      this.$Spin.hide();
    },
    //搜索 
    Search () {
      setTimeout(() => {
        this.getConsensusList()
      }, 500)
      this.$Spin.show();
    },
    change (value) {
      this.input2 = value
      this.currentPage = 1
      setTimeout(() => {
        this.getConsensusList()
      }, 500)
      this.$Spin.show();
    },
    //返回
    backProject () {
      this.$router.back()
    },
    //录入
    addConsensus () {
      this.$router.push({
        path: '/editorGongshi',
        query: {
          id: '',
          project_id: this.project_id,
        }
      })
    },
    //选择   
    async selectConsensus (item) {
      const { data: data } = await this.$http.post("project/perfect", {
        project_id: this.project_id,
        type: 'consensus_id',
        id: item.id
      })
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.getConsensusList()
    },
    //取消选择 
    async CancellationConsensus (item) {
      this.$confirm('您是否要取消选择?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post("project/delete", {
          type: 'consensus_id',
          id: item.id,
          project_id: this.project_id,
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getConsensusList()
      }).catch(() => { })
    },
    //查看
    viewConsensus (item) {
      this.$router.push({
        path: '/consensusDetails',
        query: {
          id: item.id
        }
      })
    },
    //编辑 
    editorConsensus (item) {
      this.$router.push({
        path: '/editorGongshi',
        query: {
          id: item.id,
          project_id: this.project_id,
        }
      })
    },
    //删除
    deleteConsensus (item) {
      this.$confirm('您是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('gs/del', {
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getConsensusList()
      }).catch(() => { })
    },
    //点击每一页   
    currentchange (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getConsensusList()
      }, 500)
      this.$Spin.show();
    },
    //上一页  
    prevClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getConsensusList()
      }, 500)
      this.$Spin.show();
    },
    //下一页 
    nextClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getConsensusList()
      }, 500)
      this.$Spin.show();
    },
  }
}
</script>

<style lang='less' scoped>
.projectManagement {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title_box {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
    .inputBox {
      flex: 1;
      .el-select {
        margin-right: 24px;
      }
      // .el-input {
      //   width: 30%;
      //   margin-right: 24px;
      // }
      .setDateTitle {
        margin-right: 14px;
        color: #8588ae;
        font-size: 18px;
      }
    }
  }
  .el-card {
    flex: 1;
    .iconstyle {
      font-size: 20px;
      display: inline-block;
      width: 36px;
      height: 36px;
      border: 1px solid #f1f1f1;
      text-align: center;
      line-height: 36px;
      &:hover {
        cursor: pointer;
      }
      &:nth-child(1) {
        border-right: none;
      }
      &:nth-child(2) {
        border-right: none;
      }
      &:nth-child(3) {
        border-right: none;
        font-size: 16px !important;
      }
      &:nth-child(4) {
        font-size: 16px !important;
      }
      img {
        width: 14px;
        height: 14px;
      }
    }
    .lookat {
      color: #121fcf;
    }
    .edtor {
      color: #41ab1b;
    }
    .delete {
      color: #f12937;
    }
  }
  .page {
    text-align: right;
    margin-top: 24px;
  }
  .popup {
    width: 100%;
    text-align: center;
    margin-top: 30px;
    background: url("../../assets/image/cloud.png") no-repeat 0 0 / contain;
    font-size: 18px;
    color: #212529;
    .buttons {
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      margin-top: 87px;
      .el-button:nth-child(1) {
        background: #6c757d;
        color: #fff;
      }
      .el-button:nth-child(2) {
        background: #258ce8;
        color: #fff;
      }
    }
  }
  .el-table {
    margin-bottom: 20px;
    &::before {
      height: 0;
    }
    /deep/ tbody {
      tr {
        .el-table__cell {
          border: 0 none;
        }
      }
    }
  }
  /deep/ .el-card {
    overflow: visible;
  }

  /deep/ .el-card__body {
    padding: 20px 20px 0 20px;
  }

  /deep/ .el-table__row {
    cursor: pointer;
  }
}
</style> 
